<script setup lang="ts">
import WidgetSidebar from '../components/WidgetSidebar.vue';
</script>

<template>
	<div class="grid min-h-screen phablet:pl-sidebar relative z-50">
		<WidgetSidebar class="row-span-full" />
		<div class="pt-[72px] phablet:p-10 phablet:pt-8 desktop:p-12 desktop:pt-8 widescreen:p-16 widescreen:pt-9">
			<div class="w-full row-span-full h-full">
				<slot />
			</div>
		</div>
	</div>
</template>
